// Surfaces Fly's live bundle total (hidden in Fly's config) into the ATC button and an injected price
// card, synced via MutationObserver as options change, and hides the static Liquid bundle-summary card
// on Fly pages (its price is static, wrong for a variable bundle). Rides on Fly's gfb* classes.
(() => {
  const WIDGET = '.gfbFrequentBoughtWidgetContainer';
  const BTN = '.gfbFrequentBoughtAddToCartButton';
  const TOTAL = '.gfbFrequentBoughtWidgetPriceContainerPrice';

  // Append "· £X" to a button label, idempotently (split on the separator so it never doubles up).
  const setLabel = (el, price) => {
    if (!el) return;
    const base = el.dataset.kbxBase || (el.dataset.kbxBase = el.textContent.split('·')[0].trim());
    const label = `${base} · ${price}`;
    if (el.textContent.trim() !== label) el.textContent = label;
  };

  const sync = (widget) => {
    const price = widget.querySelector(TOTAL)?.textContent.trim();
    if (!price) return;

    // Fly's own button (if shown) and the theme product-form ATC (used when Fly's button is hidden).
    setLabel(widget.querySelector(BTN), price);
    setLabel(document.querySelector('.product-form__submit .btn__text'), price);

    const cardPrice = widget.kbxCardPrice;
    if (cardPrice && cardPrice.textContent.trim() !== price) cardPrice.textContent = price;
  };

  const attach = (widget) => {
    if (widget.dataset.kbxBound) return;
    widget.dataset.kbxBound = 'true';

    // .kbx-hidden carries !important so it beats the snippet's `.bundle-summary { display: grid }`.
    const section = widget.closest('[id^="shopify-section-"]') || document;
    section.querySelectorAll('.bundle-summary').forEach((el) => {
      el.classList.add('kbx-hidden');
    });

    // Separate card above the widget (a sibling, not adjoined), matching the curated-kit price card.
    const card = document.createElement('div');
    card.className = 'fly-price-card';
    const price = document.createElement('span');
    price.className = 'fly-price-card__price';
    card.appendChild(price);
    widget.parentNode.insertBefore(card, widget);
    widget.kbxCardPrice = price;

    sync(widget);

    let scheduled = false;
    let reassert;
    new MutationObserver(() => {
      if (!scheduled) {
        scheduled = true;
        requestAnimationFrame(() => {
          scheduled = false;
          sync(widget);
        });
      }
      // Fly replaces the ATC button a beat after updating the total, which can leave the button a
      // step behind the price card; re-sync once the mutations settle so they always match.
      clearTimeout(reassert);
      reassert = setTimeout(() => sync(widget), 350);
    }).observe(widget, { childList: true, subtree: true, characterData: true });
  };

  let scanTimer;
  const scan = () => {
    clearTimeout(scanTimer);
    scanTimer = setTimeout(() => document.querySelectorAll(WIDGET).forEach(attach), 100);
  };
  scan();
  // Fly renders its widget client-side after load, so watch for it appearing (and any re-render).
  new MutationObserver((mutations) => {
    const widgetAdded = mutations.some((mutation) =>
      [...mutation.addedNodes].some(
        (node) => node.nodeType === 1 && (node.matches(WIDGET) || node.querySelector(WIDGET))
      )
    );
    if (widgetAdded) scan();
  }).observe(document.body, { childList: true, subtree: true });
})();
